import personalData from "./personalData/personalData";
import deleteModal from "./deleteModal/deleteModal";

const module = {
  personalData: personalData,
  deleteModal: deleteModal,
};

export default module;



// WEBPACK FOOTER //
// ./src/store/Module/index.js